// src/components/brandCustomization/PublicPageCustomization/PublicPageForm.jsx
import React from 'react';
import { TextInput, TextArea } from '../shared';

/**
 * PublicPageForm - Formulario genérico para textos de páginas públicas
 */
const PublicPageForm = ({ 
  pageName, 
  values, 
  onChange 
}) => {
  // Renderizado dinámico según el tipo de página
  const renderFields = () => {
    if (!values) return null;

    return Object.entries(values).map(([key, value]) => {
      if (typeof value !== 'string') return null;
      
      const isLongText = value.length > 100 || key.includes('Message') || key.includes('Description');
      
      // Convertir camelCase a Title Case
      const label = key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase());

      if (isLongText) {
        return (
          <TextArea
            key={key}
            label={label}
            value={value}
            onChange={(newValue) => onChange(`texts.${key}`, newValue)}
            rows={3}
          />
        );
      }

      return (
        <TextInput
          key={key}
          label={label}
          value={value}
          onChange={(newValue) => onChange(`texts.${key}`, newValue)}
        />
      );
    });
  };

  return (
    <div className="space-y-4">
      {renderFields()}
    </div>
  );
};

export default PublicPageForm;

